import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'react-bootstrap';
import { OpenInNew } from '@material-ui/icons';
import Link from '@material-ui/core/Link';

const styles = {
  closeButton: {
    borderRadius: '50%',
    border: 'none',
    padding: '5px',
    cursor: 'pointer',
    backgroundColor: '#F6F6F6'
  },
  closeIcon: {
    width: '24px',
    height: '24px'
  },
  header: {
    textAlign: 'right',
    padding: '16px'
  },
  dialogContent: {
    maxWidth: '333px',
    fontWeight: 500,
    fontSize: '20px',
    color: '#000000',
    lineHeight: '32px'
  },
  supportLink: {
    verticalAlign: 'middle'
  },
  supportIcon: {
    verticalAlign: 'middle',
    marginLeft: '5px'
  }
};

const enhance = compose();
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  }
});

const Main = enhance(
  ({ openHelpQrUserKid, setOpenHelpQrUserKid, isSmall, classes }) => {
    const classesD = useStyles();
    return (
      <Dialog
        open={openHelpQrUserKid}
        onClose={() => {
          setOpenHelpQrUserKid(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classesD.paperWidthSm
        }}
      >
        <div className={classes.header}>
          <Button
            className={classes.closeButton}
            onClick={() => {
              setOpenHelpQrUserKid(false);
            }}
          >
            <CloseIcon className={classes.closeIcon} color="primary" />
          </Button>
        </div>
        <DialogContent
          style={{
            padding: '0 16px 36px 16px'
          }}
        >
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogContent}
          >
            ※カード型会員証の対応は、店舗側で会員証を読み取るため、店頭にスマホやタブレットなどの端末をご用意いただく必要があります。
            <div style={{ margin: '8px 0 16px 0' }}>
              <Link
                href="https://shop-guide.gochimeshi.com/kodomogochimeshi/compatible-card/"
                target="_blank"
                className={classes.supportLink}
              >
                詳しくはこちら
                <OpenInNew color="primary" className={classes.supportIcon} />
              </Link>
            </div>
            ※カード型会員証の対応不可とした場合、利用者様のスマートフォンで操作が必要です。お子様だけで利用したいなど、利用者様がスマートフォンをお持ちでない場合はご利用いただけません。
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
